import {Box} from "@mui/material";
import styled from "@emotion/styled";
import {media} from "assets/css/media";
import {PrimaryButton} from "./button";

export const CardContainer = styled(Box)`
	background: #fff;
	padding: 12px;
	box-sizing: border-box;
	border-radius: 4px;
	box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.2);
	gap: 12px;
	margin: 0 12px;
	position: relative;
	z-index: 2;

	&:before {
		display: block;
		content: "";
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		border-radius: 4px;
		box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.2);
		background: #fff;
		transform: rotate(-1.5deg);
		z-index: -1;
	}

	ul {
		li {
			display: flex;
			height: 56px;
			padding: 0 12px;
			justify-content: space-between;
			align-items: center;
			align-self: stretch;
			border-radius: 4px;
			background: #f0f0f0;
			margin-bottom: 4px;
			gap: 12px;
		}
	}

	@media (min-width: ${media.mobile}) {
		&:before {
			content: none;
		}
	}
`;

export const CardOverlay = styled(Box)`
	position: absolute;
	width: 100%;
	height: 100%;
	background: rgba(255, 255, 255, 0.15);
	top: 0;
	left: 0;
	z-index: 3;
`;

export const SquadRow = styled(Box)`
	display: flex;
	height: 56px;
	padding: 0 8px;
	justify-content: space-between;
	align-items: center;
	align-self: stretch;
	border-radius: 4px;
	background: #f0f0f0;
	margin-bottom: 2px;
	gap: 12px;
	overflow: hidden;
	position: relative;
	cursor: pointer;

	label {
		margin-left: 0;
		margin-right: 0;

		.Mui-checked {
			color: #151515;
		}
	}

	&.selected {
		border-radius: 4px;
		border: 1px solid var(--background-dark-blue, #193361);
		background: var(--conference-nfc-pick, rgba(16, 51, 101, 0.1));
	}

	@media (min-width: ${media.mobile}) {
		margin-bottom: 4px;
	}
`;

export const DivisionName = styled("h5")`
	color: #151515;
	font-family: var(--fontFamilyBase);
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: 140%;
	margin-bottom: 12px;
	text-align: center;

	b {
		font-weight: 700;
	}

	@media (min-width: ${media.mobile}) {
		font-size: 18px;
	}
`;
export const SquadPosition = styled(Box)`
	color: #151515;
	text-align: center;
	font-family: var(--fontFamilyBase);
	font-size: 16px;
	font-style: normal;
	font-weight: 700;
	line-height: 140%; /* 22.4px */
`;
export const SlotNumber = styled(Box)`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 20px;
	height: 20px;
	color: #fff;
	font-size: 16px;
	font-weight: 600;
	position: absolute;
	top: 0;
	left: 0;
`;

export const BgImage = styled.img`
	position: absolute;
	width: 100%;
	height: auto;
	max-height: 200px;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	opacity: 0.03;
	filter: grayscale(1);
`;

export const SquadImg = styled(Box)`
	max-width: 60px;
	display: flex;
	justify-content: center;

	img {
		display: block;
		width: 70%;
	}
`;

export const WildCardSquadImgWrapper = styled.div`
	width: 48px;
	height: 48px;
	object-fit: cover;
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const WildCardSquadImg = styled.img`
	max-width: 100%;
	max-height: 100%;
	object-fit: cover;
`;

export const CardButton = styled(PrimaryButton)`
	margin: 8px auto 0;
	height: 40px;
`;

export const TeamPosition = styled(Box)`
	margin-right: 4px;
	display: flex;
	justify-content: center;
	align-items: center;

	span {
		margin-right: 0;
		min-width: 16px;
	}

	&.left {
		margin-right: 2px;
	}

	&.right {
		margin-right: 0;
		margin-left: 2px;
	}
`;
export const SquadInfo = styled(Box)`
	flex: 1 2 100%;
	display: flex;
	align-items: center;
	gap: 2px;
	position: relative;

	&.align-start {
		align-items: flex-start;
	}

	&.align-end {
		align-items: flex-end;
	}
`;
export const SquadName = styled(Box)`
	flex: 1;
	display: flex;
	align-items: self-end;

	&.right {
		flex: none;
	}
`;
export const SquadResults = styled(Box)`
	flex: 1 1 20%;
	display: flex;
	justify-content: center;

	&.no-wrap {
		white-space: nowrap;
	}
`;
export const UndraftedBox = styled(Box)`
	display: grid;
	grid-template-columns: 1fr 1fr 1fr 1fr;
	gap: 4px;
	overflow: auto;

	&::-webkit-scrollbar {
		background-color: #fff;
		width: 16px;
	}

	&::-webkit-scrollbar-track {
		background-color: #fff;
	}

	&::-webkit-scrollbar-track:hover {
		background-color: #f4f4f4;
	}

	&::-webkit-scrollbar-thumb {
		background-color: #babac0;
		border-radius: 16px;
		border: 5px solid #fff;
	}

	&::-webkit-scrollbar-thumb:hover {
		background-color: #a0a0a5;
		border: 4px solid #f4f4f4;
	}

	&::-webkit-scrollbar-button {
		display: none;
	}
`;
export const UnDraftedSlot = styled(Box)<{bg?: string}>`
	border-radius: 4px;
	cursor: pointer;
	overflow: hidden;
	background: #f0f0f0;

	input {
		display: none;
	}

	label {
		width: 100%;
		min-height: 80px;
		padding: 3px 0 6px;
		cursor: pointer;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		gap: 2px;
		position: relative;
	}

	input:checked + label {
		background: ${({bg}) => (bg ? bg : "#103365")};
		color: #fff;
	}

	input:disabled + label {
		opacity: 0.5;
	}
`;
